import { Observable, Subscription, firstValueFrom } from "rxjs";
import { MINUTES } from "../const/time";

export class RecurrentFetch<T>
{
  private readonly resolve: (result: T) => void
  private readonly error:(e: Error) => void;

  private action: () => Observable<T>
  private timeInMinutes: number;

  private fetchQueue: Subscription[] = [];

  private timeout = null;

  public get isFetching() {
    return this.fetchQueue.length > 0;
  }
  public get isActive() {
    return this.timeout != null;
  }

  private constructor(action: () => Observable<T>, timeInMinutes: number, consumeResult: (result: T) => void, consumeError: (e: Error) => void) {
    this.action = action;
    this.timeInMinutes = timeInMinutes;
    this.resolve = consumeResult;
    this.error = consumeError;
  }

  public static FetchIn<T>(action: () => Observable<T>, timeInMinutes: number, consumer: FetchParameter<T>): RecurrentFetch<T> {
    return new RecurrentFetch(action, timeInMinutes * MINUTES, consumer.resolve, consumer.error)
  }

  public startFetch() { // Future Optimization to stop already called requests and create new ones
    if (this.fetchQueue.length > 1) {
      return;
    }

    let sub = this.action().subscribe({
      next: result => {
        this.resolve(result)
        this.fetchQueue.pop();
      } ,
      error: e => {
        this.error(e)
        this.fetchQueue.pop();
      }
    });
    this.fetchQueue.unshift(sub);

    this.timeout = setInterval(() => {
      sub = this.action().subscribe({
        next: result => {
          this.resolve(result)
          this.fetchQueue.pop();
        },
        error: e => {
          this.error(e)
          this.stopFetch();
          this.fetchQueue.pop();
        },
      });

      this.fetchQueue.unshift(sub);
    }, this.timeInMinutes);

  }

  public resetFetch(newTimeInMinutes: number, newAction: () => Observable<T> = this.action) {
    this.stopFetch();

    this.action = newAction;
    this.timeInMinutes = newTimeInMinutes * MINUTES;
    this.startFetch();
  }

  public stopFetch() {
    const timeout = this.timeout;
    clearInterval(timeout);
    this.timeout = null;
  }
}

export interface FetchParameter<T> {
  resolve: (result: T) => void;
  error: (e: Error) => void;
}
